// extracted by mini-css-extract-plugin
export default {"password-box":"styles_password-box__C87p+"};